// extracted by mini-css-extract-plugin
export var button = "collapse-module--button--6bee3";
export var collapse = "collapse-module--collapse--c0d45";
export var content = "collapse-module--content--69e15";
export var inner = "collapse-module--inner--32265";
export var light = "collapse-module--light--c7b0e";
export var open = "collapse-module--open--603a1";
export var primary = "collapse-module--primary--e1c1f";
export var secondary = "collapse-module--secondary--a898f";